import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import React from 'react';
import { Roster } from './models/api';
import { WithData } from './WithData';
import LoadingBackdrop from './LoadingBackdrop';
import dayjs from './RosterDayJS';
import { Days, Positions, Departments } from './tablemodels';
import DepartmentAccordion from './DepartmentAccordion';
import memoize from 'memoize-one';

const styles = ({ typography }: Theme) => createStyles({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: typography.pxToRem(15),
      fontWeight: typography.fontWeightMedium,
    },
    details: {
      display: 'unset',
      padding: 0,
    },
  });

class RosterTable extends React.Component<{ startDate: Date } & WithData & WithStyles<typeof styles>, { data?: Departments, departments: string[]}> {

    private readonly departments = memoize((data: any, startDate: Date): Departments => pivot(data, startDate));

    render() {
        if (this.props.loading) {
          return <LoadingBackdrop />
        }

        const { classes, data, startDate } = this.props;
        const departments = this.departments(data, startDate);

        return (<div className={classes.root}>
            { data && Array.from(departments.entries()).map(([department, positions]: [string, Positions]) => (
                <DepartmentAccordion key={department} department={department} positions={positions} />
            )) }
          </div>);
    }
}

export default withStyles(styles)(RosterTable);

const pivot = (roster: Roster, startDate: Date): Departments => {
  
    if (!roster) {
      return new Map<string, Positions>();
    }
  
    const pivot : Departments = new Map();
    
    for (let [deptName, day] of Object.entries(roster)) {
      let positions: Positions | undefined = pivot.get(deptName);
      for (let [dayName, position] of Object.entries(day)) {
        const date = dayjs(dayName).toDate();
        for (let [positionName, shifts] of Object.entries(position)) {
          let days: Days | undefined = positions?.get(positionName);
          if (!positions) {
            positions = new Map();
            pivot.set(deptName, positions);
          }

          if (!days) {
            days = new Map();
            positions.set(positionName, days);
          }

          days.set(date.getTime(), shifts);
        }
      }
    }
  
    return pivot;
  }